import { useEffect, useRef } from "react";
import { useNavigate } from "react-router";

const isAiAdvisorPopupLink = (anchor) => {
  const href = (anchor.getAttribute("href") || "").trim().toLowerCase();
  const label = (anchor.textContent || "").replace(/\s+/g, " ").trim();

  // Explicit advisor popup targets (same as top-nav AI Advisor).
  if (href === "#investmentmodal" || href.includes("investmentmodal") || href.includes("ai-advisor")) {
    return true;
  }

  // Label match only when the link is not navigating to a blog article page.
  if (!/ai\s*advisor/i.test(label)) {
    return false;
  }

  return !(href.includes("ai-real-estate-search-india") || href.startsWith("/blog/"));
};

function BlogHtmlContent({ styles = "", html = "", className = "", onAdvisorClick }) {
  const rootRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const root = rootRef.current;
    if (!root) {
      return undefined;
    }

    const onClick = (event) => {
      const anchor = event.target.closest("a[href]");
      if (!anchor || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }

      if (isAiAdvisorPopupLink(anchor)) {
        event.preventDefault();
        onAdvisorClick?.();
        return;
      }

      const href = anchor.getAttribute("href");
      if (!href || href.startsWith("#") || href.startsWith("mailto:") || href.startsWith("tel:") || /^https?:\/\//i.test(href)) {
        return;
      }

      event.preventDefault();
      navigate(href);
    };

    root.addEventListener("click", onClick);
    return () => root.removeEventListener("click", onClick);
  }, [navigate, html, onAdvisorClick]);

  return <div className={`vd-blog ${className}`.trim()} ref={rootRef}>
      {styles ? <style dangerouslySetInnerHTML={{ __html: styles }} /> : null}
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </div>;
}

export default BlogHtmlContent;
